import axios from "axios";
import React, { useState, useEffect } from "react";
import { Form, Row, Col, Container } from "react-bootstrap";
import { MDBInput, MDBTextArea } from "mdb-react-ui-kit";
import apiUrls from "../../../Api/MainApi";
import "./index.css";
import { DatePicker, Select } from "antd";
import moment from "moment";

// Function to validate if the date is not a future date
const isValidDate = (date) => {
  const today = new Date();
  const inputDate = new Date(date);
  return inputDate <= today;
};

const NomineeDetailsForm = ({ formData, setFormData, setIsFormValid }) => {
  const [errors, setErrors] = useState({});
  const [RelationShipData, setRelationShipData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.GetRelationshipDropDown);
        setRelationShipData(response.data.data);
      } catch (error) {
        console.error("Error fetching RelationShip data:", error);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let error = { ...errors };

    // Validation and regex
    switch (name) {
      case "NomineeName":
        if (!value.trim()) {
          error[name] = "Nominee name is required";
        } else {
          delete error[name];
        }
        break;
      case "NomineeDOB":
        if (!value) {
          error[name] = "Date of Birth is required";
        } else if (!isValidDate(value)) {
          error[name] = "Date of Birth cannot be in the future";
        } else {
          delete error[name];
        }
        break;
      case "NomineeAddress":
        if (!value.trim()) {
          error[name] = "Nominee Address is required";
        } else {
          delete error[name];
        }
        break;
      default:
        break;
    }

    // Update form data
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    // Update errors
    setErrors(error);

    // Determine if form is valid
    const hasErrors = Object.keys(error).length > 0;
    console.log(hasErrors)
    setIsFormValid(!hasErrors);
  };
  const handleDateChange = (date, dateString) => {
    let error = { ...errors };

    if (!dateString) {
      error.NomineeDOB = "Date of Birth is required";
    } else if (!isValidDate(dateString)) {
      error.NomineeDOB = "Date of Birth cannot be in the future";
    } else {
      delete error.NomineeDOB;
    }

    setErrors(error);

    setFormData({
      ...formData,
      NomineeDOB: dateString ? moment(dateString).format('YYYY-MM-DD') : '',
    });

    // Determine if form is valid
    const hasErrors = Object.keys(error).length > 0;
    setIsFormValid(!hasErrors);
  };
  const handlRelationShipNameChange = (selectedOption) => {
  
    setFormData(prevFormData => ({
      ...prevFormData,
      RelationShip: selectedOption, // Set the selected bank object
    }));
  };
  const formatDate = (date) => {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${year}-${month}-${day}`;
  };
  const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (
    <div className="FormCss">
      <div className="form-container">
        <Container>
          <Row>
            <Col>
              <Form autoComplete="off" className="form-md position-relative">
                <h2>Nominee Details</h2>
                <div className="form-section">
                  <div className="input-row">
                    <div className="form-group">
                      <MDBInput
                        type="text"
                        name="NomineeName"
                        value={formData.NomineeName}
                        onChange={handleChange}
                        required
                        id="NomineeName"
                        label="Nominee Name"
                      />
                      {errors.NomineeName && (
                        <div className="error" style={{ color: 'red' }}>{errors.NomineeName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      {/* <Form.Select
                        name="RelationShip"
                        value={formData.RelationShip}
                        onChange={handleChange}
                        required
                        className="costom-select"
                        style={{
                          color: formData.RelationShip ? "black" : "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        <option value="" disabled hidden style={{ color: '#FF0000' }}>Select RelationShip &#42;</option>
                        {RelationShipData.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </Form.Select> */}
                      <Select
                      name="RelationShip"
                       value={formData.RelationShip}
                       onChange={handlRelationShipNameChange}
                        options={(RelationShipData || []).map((RelationShip) => ({ value: RelationShip.id, label: RelationShip.name }))}
                        placeholder="Select RelationShip"
                        required
                        id="RelationShip"
                        style={{ width: '100%' ,height:"42px" }}
                        filterOption={filterOption}
                      />
                    </div>
                  </div>
                  <div className="input-row">
                    <div className="form-group">
                      {/* <MDBInput
                        type="date"
                        name="NomineeDOB"
                        value={formatDate(formData.NomineeDOB)}
                        onChange={handleChange}
                        required
                        id="NomineeDOB"
                        label="Date of Birth"
                      /> */}
                      <DatePicker
                        name="NomineeDOB"
                        defaultValue={formData.NomineeDOB ? moment(formData.NomineeDOB, 'YYYY-MM-DD') : null}
                        onChange={handleDateChange}
                        required
                        format="YYYY-MM-DD"
                        style={{ width: '100%' }}
                        disabledDate={(current) => current && current > moment().endOf('day')} // Disable future dates
                      />
                      {errors.NomineeDOB && (
                        <div className="error" style={{ color: 'red' }}>{errors.NomineeDOB}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <MDBTextArea
                        name="NomineeAddress"
                        value={formData.NomineeAddress}
                        onChange={handleChange}
                        required
                        id="NomineeAddress"
                        style={{ width: "100%", resize: "none" }}
                        placeholder="Nominee Address"
                        label="Nominee Address"
                      />
                      {errors.NomineeAddress && (
                        <div className="error" style={{ color: 'red' }}>{errors.NomineeAddress}</div>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default NomineeDetailsForm;